import { MultiSelect, SimpleGrid, TextInput, Button, Modal, Text, Center, NumberInput, Select } from "@mantine/core";
import useLevelRow from "./useLevelRow";
import { useEffect, useState } from "react";
import useAdvanced from "../useAdvanced";

function LevelRow({ field, index, stepData, removeUnusedSteps }) {

    const {
        getAllTypeOfMonthsQuery: { data, isLoading },
    } = useAdvanced()




    const {
        handleInputChange, step, handleMultiSelectChange,
        setStep,
        renameStep, removeStep, saveStep, opened, close, open } = useLevelRow(index, stepData, removeUnusedSteps);

    //console.log(step?.typeOfMonth, data);

    return (
        <>
            <div
                key={step.id}
                style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h2>{step.name}</h2>
                    <Button size="xs" variant="outline" onClick={() => renameStep(step.id)}>
                        Rename
                    </Button>
                </div>

                <SimpleGrid cols={{ base: 1, sm: 2, lg: 2 }}>
                    <MultiSelect
                        label="Select type of months"
                        placeholder="Pick bonuses"
                        data={data ?? []}
                        value={step?.typeOfMonth ?? []}  // This sets the selected values
                        onChange={(value) => {
                            handleMultiSelectChange(value)

                        }}
                        searchable
                        // nothingFoundMessage="Nothing found"
                        style={{ marginTop: '10px' }}
                    />

                </SimpleGrid>
                <br></br>
                {step?.fields?.map((field, index) => (
                    <SimpleGrid
                        cols={{ base: 1, sm: 2, lg: 2 }}
                    // breakpoints={[{ maxWidth: 768, cols: 1 }]}
                    >
                        <SimpleGrid cols={1}  >
                            <label style={{ flex: 1 }}>{field.label}</label>
                        </SimpleGrid>
                        <SimpleGrid cols={2} style={{ paddingBottom: '10px' }} >
                            <NumberInput
                                placeholder="Enter value"
                                value={field?.value}
                                onChange={(value) => handleInputChange(step?.id, index, value)}
                            //style={{ flex: 1 }}
                            />

                            <TextInput value={field?.currency}></TextInput>
                        </SimpleGrid>

                    </SimpleGrid>

                ))
                }
                < div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                    <Button mt="md" variant="default" onClick={() => open()}>
                        Delete
                    </Button>
                    <Button
                        mt="md"
                        variant="gradient"
                        gradient={{ from: "#44FFFA", to: "#FF4267", deg: 90 }}
                        onClick={() => saveStep(step.id)}
                    >
                        Save
                    </Button>
                </div>

                <Modal opened={opened} onClose={close}
                    centered
                    title="Confirm">

                    <Text>Are you sure you want to delete {step?.name} level ?</Text>


                    <Center mt={"md"}>
                        <Button onClick={() => removeStep(step.id)}
                        // loading={isPending}
                        >Confirm</Button>
                    </Center>

                </Modal>


            </div >

        </>
    );
}

export default LevelRow;
